export default __webpack_public_path__ + "static/media/separator-1.a73ea03c.svg";